import Axios from 'configs/Axios';
import {
  ApptOptionResponseData,
  ApptOptionsFilters,
  ApptOptionsFormValues,
} from 'types/apptOptions';

export const getApptOptions = (filters: ApptOptionsFilters) =>
  Axios.get<ApptOptionResponseData>('/apptOption', {
    params: filters,
  });

export const deleteApptOption = (apptOptionId: string) =>
  Axios.delete(`/apptOption/${apptOptionId}`);

export const addNewApptOption = (data: ApptOptionsFormValues) =>
  Axios.post<ApptOptionResponseData>('/apptOption', data);

export const updateApptOption = (data: ApptOptionsFormValues) =>
  Axios.put('/apptOption', data);
